import { IconAlertTriangle } from '@tabler/icons-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';

export function ImpersonationBanner() {
  const { impersonation, stopImpersonation, user } = useAuth();

  if (!impersonation?.isImpersonating) {
    return null;
  }

  const handleStopImpersonation = async () => {
    try {
      await stopImpersonation();
    } catch (error: any) {
      toast.error(error.message || 'Failed to stop impersonation');
    }
  };

  return (
    <div className="sticky top-0 z-50 bg-warning text-warning-foreground py-3 px-4 border-b-2 border-warning/80">
      <div className="flex items-center justify-between gap-4 flex-wrap md:flex-nowrap">
        <div className="flex items-center gap-3 min-w-0 flex-1">
          <IconAlertTriangle className="h-7 w-7 shrink-0" />
          <div className="min-w-0">
            <div className="font-bold text-[0.95rem] mb-0.5">Impersonation Mode Active</div>
            <div className="text-sm opacity-95">
              Viewing as <strong>{user?.name}</strong> ({user?.email})
              {impersonation.realAdmin && (
                <> &middot; Admin: <strong>{impersonation.realAdmin.name}</strong></>
              )}
            </div>
          </div>
        </div>
        <Button
          variant="outline"
          onClick={handleStopImpersonation}
          className="font-bold border-2 border-warning-foreground/50 hover:border-warning-foreground hover:bg-black/10 shrink-0 whitespace-nowrap min-w-full sm:min-w-0"
        >
          Stop Impersonating
        </Button>
      </div>
    </div>
  );
}
